// /* eslint-disable */
// import { useEffect } from "react";
// import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import { useDispatch } from "react-redux";

// import AppLayout from "./common/components/AppLayout";
// // import { getAPIRepoVersion } from './registration_login/actions/sessionActions';
// // import SupportProfileDisplay from './support/components/SupportProfileDisplay';

// import "./App.css";

// function App() {
//   const dispatch = useDispatch();

//   useEffect(() => {
//     // dispatch(getAPIRepoVersion());
//   }, [dispatch]);

//   return (
//     <Router>
//       <Routes>
//         <Route path="*" element={<AppLayout />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;


/* eslint-disable */
import { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useDispatch } from "react-redux";
import AppLayout from "./common/components/AppLayout";
import "./App.css";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="*" element={<AppLayout />} />
      </Routes>
    </Router>
  );
}

export default App;
